// extracted by mini-css-extract-plugin
module.exports = {"root":"PrimaryNav_root__1k9nW","visible":"PrimaryNav_visible__2efim","compact":"PrimaryNav_compact__36BG6","landscape":"PrimaryNav_landscape__2bCPm"};